import { useConditionState } from '../../../hooks/condition';
import { useQueryStateContext } from '../../../contexts';

export const useIsCurrentConditionId = () => {
  const { recentQueryId } = useQueryStateContext();
  const {
    condition: { id },
  } = useConditionState();
  return recentQueryId === id;
};
